import { useState } from 'react';
import { CompetitionClient, CompetitionDTO, ApiResponse_string, SearchRequestDTO_CompetitionSearchRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useCompetitionApi = () => {
    const apiClient = new CompetitionClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: CompetitionDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createCompetition(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Competition');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: CompetitionDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateCompetition(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Competition');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getCompetitionById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Competition');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchCompetitions(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Competitions');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteCompetition(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Competition');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
        filters: any
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.exportCompetitions(filters);
        } catch (err: unknown) {
            handleHookError(err, 'Error exporting Competitions', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, extract, remove, isLoading, error };
};